"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QrCodeDialog = void 0;
var _components = require("@ori-ui/components");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useTranslations = require("../../hooks/useTranslations");
var _DownloadQrCode = require("../DownloadQrCode");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const QrCode = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require('../QrCode')))).QrCode
}));
const QrCodeDialog = ({
  onClose,
  open
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const footer = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_DownloadQrCode.DownloadQrCode, {}), []);
  const content = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Loading, {}),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(QrCode, {})
  }), []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Dialog, {
    drawer: true,
    "data-testid": getTestId(_constants.QR_CODE_DIALOG),
    open: open,
    transitionProps: _constants.transitionProps,
    header: translations.generateQrCode,
    footer: footer,
    onClose: onClose,
    children: content
  });
};
exports.QrCodeDialog = QrCodeDialog;
